// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import PoolAvailability from './poolAvailability';
import React from 'react';

function PoolAvailabilityPage () {

    return (
        <AuthenticatedPage className="atp-page atp-pool-availability-page">
            <PoolAvailability />
        </AuthenticatedPage>
    );

}
PoolAvailabilityPage.displayNAme = 'PoolAvailabilityPage';

export default PoolAvailabilityPage;
